import { h, Fragment } from 'preact';
import Image from 'utils/image';
import { useProduct } from './product-context';

const ProductValueProps = () => {
  const { activeProduct, data } = useProduct();

  const productValueLength = data.productValueProps.length;
  let checkContent = false;
  data.productValueProps.map((value, index) => {
    if (value.text != '') {
      checkContent = true;
    }
  });

  if (data.productValueProps.length == 0 || checkContent == false) return;

  return (
    <div className="product-value-props py-[30px] border-b-1 border-grey-400">
      <div className="product-value-props__icons">
        {data.productValueProps.map((value, index) => {
          return (
            <>
              {value.text && (
                <div
                  className={
                    'product-value-props__single-line flex items-center ' +
                    (productValueLength - 1 == index ? null : 'mb-[15px]')
                  }
                >
                  <Image {...value.imageObject} additionalClasses="w-[42px]" />
                  <span key={index} className="text-s2 pl-[15px]">
                    {value.text}
                  </span>
                </div>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ProductValueProps;
